import React from "react";
import { useTheme } from "@mui/material";
import { SovosBox, SovosButton, SovosTypography } from "mosaic-react";
import { SovosAIIcon } from "mosaic-react-platform";
import { AI_BRAND_GRADIENT_PINK } from "mosaic-react-platform/shared/aiBrandGradient";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const REVIEW_BUTTON_SX = {
    fontSize: "0.75rem",
    textTransform: "uppercase",
};

const SoviSuggestionsBanner = ({
    fixCount,
    onReviewRules,
    onReviewSuggestions,
    ruleCount,
    working = false,
}) => {
    const { i18n } = useGlobalValue();
    const { palette } = useTheme();
    const fixLabel = fixCount === 1 ? i18n`fix` : i18n`fixes`;
    const ruleLabel = ruleCount === 1 ? i18n`rule` : i18n`rules`;

    return (
        <SovosBox
            sx={{
                alignItems: "center",
                bgcolor: working ? "warning.light" : `${AI_BRAND_GRADIENT_PINK}14`,
                borderRadius: 1,
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
                justifyContent: "space-between",
                px: 2,
                py: 1.5,
            }}
        >
            <SovosBox sx={{ alignItems: "center", display: "flex", gap: 1.5 }}>
                <SovosBox
                    sx={{
                        alignItems: "center",
                        display: "flex",
                        "& svg": { height: 24, width: 24 },
                    }}
                >
                    <SovosAIIcon />
                </SovosBox>
                <SovosTypography variant="body2">
                    {working
                        ? i18n`Sovi AI is working on your data validation. It might take a few minutes...`
                        : i18n`Sovi AI has suggested ${fixCount} ${fixLabel} and ${ruleCount} ${ruleLabel}, you can accept them or ignore them.`}
                </SovosTypography>
            </SovosBox>
            {!working && (
                <SovosBox sx={{ alignItems: "center", display: "flex", gap: 1 }}>
                    <SovosButton
                        size="small"
                        variant="text"
                        color={palette.text.primary}
                        sx={REVIEW_BUTTON_SX}
                        onClick={onReviewSuggestions}
                    >
                        {i18n`Review fixes`}
                    </SovosButton>
                    <SovosButton
                        size="small"
                        variant="text"
                        color={palette.text.primary}
                        sx={REVIEW_BUTTON_SX}
                        onClick={onReviewRules}
                    >
                        {i18n`Review rules`}
                    </SovosButton>
                </SovosBox>
            )}
        </SovosBox>
    );
};

export default SoviSuggestionsBanner;
